import {
  START_ALGO,
  UPDATE_ALGO,
  COMPLETE_ALGO,
  SET_ALGO_PREVIEW,
  RESET_ALGO,
  CANCEL_ALGO,
  SET_LAST_UPDATED,
} from "../types/algo";

export const startAlgo = (params) => ({
  type: START_ALGO,
  payload: params,
});

export const setLastUpdated = (payload) => ({
  type: SET_LAST_UPDATED,
  payload,
});

export const updateAlgo = (params) => ({
  type: UPDATE_ALGO,
  payload: params,
});

export const completeAlgo = (params) => ({
  type: COMPLETE_ALGO,
  payload: params,
});

export const cancelAlgo = (params) => ({
  type: CANCEL_ALGO,
  payload: params,
});

export const setAlgoPreview = (params) => ({
  type: SET_ALGO_PREVIEW,
  payload: params,
});

export const resetAlgo = (params) => ({
  type: RESET_ALGO,
  payload: params,
});
